export default __webpack_public_path__ + "static/media/ktcl_03.dda659f7.png";